import { render, staticRenderFns } from "./IcoMoon.vue?vue&type=template&id=6557f8b2&"
import script from "./IcoMoon.vue?vue&type=script&lang=js&"
export * from "./IcoMoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6557f8b2')) {
      api.createRecord('6557f8b2', component.options)
    } else {
      api.reload('6557f8b2', component.options)
    }
    module.hot.accept("./IcoMoon.vue?vue&type=template&id=6557f8b2&", function () {
      api.rerender('6557f8b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/icons/IcoMoon.vue"
export default component.exports